export const DASHBOARD_PATH = '/';
export const WELCOME_PATH = '/welcome';

// API URL

// export const API_URL = "http://localhost:8081/api";
// export const BASE_URL = "http://localhost:8081/";

export const API_URL = "https://axopeople.com/api";
export const BASE_URL = "https://axopeople.com/";

export const IMAGE_BASE_URL = "https://axopeople.blob.core.windows.net/images/";
export const RESUME_BASE_URL = "https://axopeople.blob.core.windows.net/resumes/";

const config = {
  fontFamily: `'Roboto', sans-serif`,
  borderRadius: 8,
  mode: 'light',  // Theme mode: 'light' or 'dark'
  presetColor: 'default',
  outlinedFilled: true
};

export default config;
